export default function registerBookingCalendar(Alpine) {
  Alpine.data("bookingCalendar", () => ({
    selectedSlot: null,
    submitting: false,
    visitorTimezone: null,
    hostTimezone: "",

    init() {
      this.hostTimezone = this.$el.dataset.timezone || "";

      try {
        this.visitorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch {
        this.visitorTimezone = null;
      }
    },

    selectSlot(event) {
      const button = event.currentTarget;
      const start = button.dataset.start;
      const displayTime = button.dataset.displayTime;
      const displayEnd = button.dataset.displayEnd;
      const displayDate = button.dataset.displayDate;

      // Set selected slot — Alpine :class bindings handle styling reactively
      this.selectedSlot = start;

      // Set form hidden input value
      if (this.$refs.startTime) this.$refs.startTime.value = start;

      // Build time display with host timezone
      let timeText = `${displayDate}, ${displayTime} \u2013 ${displayEnd}`;
      if (this.hostTimezone) timeText += ` (${this.hostTimezone})`;

      // Add visitor timezone if different
      if (this.visitorTimezone && this.visitorTimezone !== this.hostTimezone) {
        const startDate = new Date(start);
        const endDate = new Date(button.dataset.end);
        const opts = {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
          timeZone: this.visitorTimezone
        };
        const localStart = startDate.toLocaleTimeString([], opts);
        const localEnd = endDate.toLocaleTimeString([], opts);
        timeText += ` \u00b7 ${localStart} \u2013 ${localEnd} (${this.visitorTimezone})`;
      }

      if (this.$refs.selectedTimeDisplay) {
        this.$refs.selectedTimeDisplay.textContent = timeText;
      }

      // Scroll form into view and move focus for screen readers
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        if (this.$refs.selectedTimeDisplay) {
          this.$refs.selectedTimeDisplay.setAttribute("tabindex", "-1");
          this.$refs.selectedTimeDisplay.focus({ preventScroll: true });
        }
      });
    },

    formatVisitorTime(isoString) {
      if (!this.visitorTimezone) return "";
      const date = new Date(isoString);
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: this.visitorTimezone
      });
    },

    disableSubmit(event) {
      if (this.submitting) {
        event.preventDefault();
        return;
      }
      this.submitting = true;
      setTimeout(() => {
        const btn = this.$refs.submitBtn;
        if (btn) {
          btn.disabled = true;
          btn.setAttribute("aria-disabled", "true");
          btn.textContent = btn.textContent.trim() + "\u2026";
        }
      }, 0);
    }
  }));
}
